import React, { useState } from 'react';
import { Paper } from '@mui/material';

import DashboardContainer from '../../components/admin/DashboardContainer';
import MessageList from '../../components/messages/MessageList';
import { useCompany } from '../../contexts/Company';

import MessageEditor from '../../components/admin/messages/MessageEditor';
import { SelectCompany } from '../../components/admin/SelectCompany';
import { useEffect } from 'react';

export default function Messages() {
    const [selectedCompanyId, setSelectedCompanyId] = useState(null);
//    const company = useCompany();

    return (
        <DashboardContainer title={'Mensajes'}>
            <Paper sx={{ p: 4 }}>
                <SelectCompany 
                    selectedCompanyId={selectedCompanyId}
                    setSelectedCompanyId={setSelectedCompanyId}/>
                <MessageList companyId={selectedCompanyId} canEdit={true} />
                <MessageEditor companyId={selectedCompanyId}/>
            </Paper>

        </DashboardContainer>
    );
}